import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SettingsApplicationsIcon from "@mui/icons-material/SettingsApplications";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Box } from "@mui/material";
import { Menu, useSidebarState } from "react-admin";
import { BrandLogo } from "../ui/BrandLogo";
import { brandIconSx } from "../ui/brandIcon";

export const AdminMenu = () => {
  const [open] = useSidebarState();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          py: 2,
          px: 1,
          opacity: open ? 1 : 0.85,
        }}
      >
        <BrandLogo size={open ? 52 : 40} />
      </Box>
      <Menu>
        <Menu.ResourceItem name="phphrase" />
        <Menu.ResourceItem name="phmusic" />
        <Menu.ResourceItem name="phemotions" />
        <Menu.ResourceItem name="phintro" />
        <Menu.ResourceItem name="phbreathing" />
        <Menu.ResourceItem name="phemotiontype" />
        <Menu.ResourceItem name="phhomesection" />
        <Menu.Item
          to="/helpers/digar"
          primaryText="Digər köməkçilər"
          leftIcon={<SupportAgentIcon sx={brandIconSx} />}
        />
        <Menu.Item to="/helpers/more" primaryText="Daha çox" leftIcon={<MoreHorizIcon sx={brandIconSx} />} />
        <Menu.ResourceItem name="phmappoint" />
        <Menu.ResourceItem name="phnews" />
        <Menu.ResourceItem name="phblog" />
        <Menu.ResourceItem name="phabout" />
        <Menu.ResourceItem name="phcatalog" />
        <Menu.ResourceItem name="phvideo" />
        <Menu.ResourceItem name="phgame" />
        <Menu.Item
          to="/phappconfig/1/edit"
          primaryText="App parametrləri"
          leftIcon={<SettingsApplicationsIcon sx={brandIconSx} />}
        />
        <Menu.ResourceItem name="exceptionlog" />
        <Menu.ResourceItem name="slowrequestlog" />
      </Menu>
    </>
  );
};
